import React from "react";
import { Col, List, Icon, Input, Modal, Row, Button, message, Steps } from "antd";
import debounce from "debounce";

import { 
    _getElasticSearchProducts, 
    _getSearchProducts,
    _getReadTagsFromRfidServer,
    _postGenerateRfidTag, 
    _postWriteTagsToRfidServer,
    _postSetRetagSuccess
} from "../../services";

class TagProductModal extends React.Component{

    constructor( props ){
        super(props);

        this.doDebouncedSearchProducts = debounce( this.doDebouncedSearchProducts, 500 );

        this.state = {
            searchParam: "",
            pendingProductSearchResults: false,
            retagOperationStep: 0,
            pendingRetagOperation: false,
            productsFound: [],
            selectedProductToTag: null,
            selectedVariantSetIds: []
        };
    }

    render( ){
        return(
            <Modal
                closable={false}
                maskClosable={false}
                footer={null}
                visible={true}>

                {
                    this.state.pendingRetagOperation && this.renderRetagOperationProgress()
                }

                {/* @todo create render method for main product selector ui */}
                {
                    !this.state.pendingRetagOperation && [
                        this.renderProductSelector(),
                        this.renderVariantSelector(),    
                        this.renderRfidTagsSelected(),    
                        this.renderControls()
                    ]
                }

            </Modal>
        )
    }

    renderControls = () => {

        let disableTagging = false;

        for (let i = 0; i < this.state.selectedVariantSetIds.length; i++) {

            const selectedVariant = this.state.selectedVariantSetIds[i];

            if( !selectedVariant ){
                disableTagging = true;
            }
            
        }

        if( !this.state.selectedProductToTag ){
            disableTagging = true;
        }

        return (
            <Row type="flex" justify="end" gutter={8}>
                <Col>
                    <Button onClick={this.props.onCancel}>
                        Cancel
                    </Button>
                </Col>

                <Col>
                    <Button
                        onClick={ this.handleOnTagProducts } 
                        disabled={disableTagging}
                        type="primary">
                        Tag
                    </Button>
                </Col>
            </Row>
        )

    }

    renderProductSelector = () => {
        return (
            <div style={{ position: "relative" }}>
                <h4>Product</h4>
                <Input 
                    value={ this.state.searchParam }
                    onChange={ this.handleOnSearchProduct } />

                {
                    this.state.productsFound.length === 0 && 
                    this.state.searchParam && 
                    !this.state.pendingProductSearchResults && 
                    !this.state.selectedProductToTag && (
                        <div>No Products Found</div>
                    )
                }

                {this.state.productsFound.length > 0 && (
                    <List style={{ 
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                        position: "absolute", 
                        top: 60, 
                        left: 0, 
                        background: "white", 
                        zIndex: 999, 
                        padding: 8, 
                        borderRadius:8 }}>
                            
                        {this.state.productsFound.map( _p => {
                            return (
                                <List.Item style={{ cursor: "pointer" }} onClick={ () => this.handleOnSelectProductToTag( _p ) }>
                                    {_p.title} - {_p.shopNumber}
                                </List.Item>
                            )
                        })}
                    </List>
                )}
            </div>
        )
    }

    renderRetagOperationProgress = () => {

        let current = this.state.retagOperationStep;

        let renderTitle = ( stepIndex, currentStep ) => {
            if( stepIndex === currentStep ){
                return "In Progress";
            }

            if( stepIndex < currentStep ){
                return "Finished";
            }

            if( stepIndex > currentStep ){
                return "Waiting";
            }
        }

        let renderIcon = ( stepIndex, currentStep ) => {

            if( stepIndex === currentStep ){
                // return "In Progress";
                return <Icon type="loading"  />;
            }

            if( stepIndex < currentStep ){
                return <Icon type="check-circle" style={{ color: "#52c41a"}}  />;
            }

            if( stepIndex > currentStep ){
                return null;
            }



        }

        return ( 
            <div>

                <Steps current={current} direction="vertical">
                    <Steps.Step 
                        icon={renderIcon(0, current)}
                        title={renderTitle( 0, current )} 
                        description="Request latest tag ids from the server" />
                    <Steps.Step 
                        icon={renderIcon(1, current)}
                        title={renderTitle( 1, current )} 
                        description="Write eezee tag ids to physical tags" />
                    <Steps.Step 
                        icon={renderIcon(2, current)}
                        title={renderTitle( 2, current )} 
                        description="Verify tags are written" />
                    <Steps.Step 
                        icon={renderIcon(3, current)}
                        title={renderTitle( 3, current )} 
                        description="Notify server of retag success" />
                </Steps>
                
            </div>
        )

    }

    renderRfidTagsSelected = () => {
        return (
            <div style={{ marginTop: 32 }} >
                <h4>Rfid Tags: {this.props.selectedRfidTags.length}</h4>
                <div>
                    {this.props.selectedRfidTags.map(
                        rfidTag => (
                            <div key={rfidTag.tagId}>{rfidTag.tagId}</div>
                        )
                    )}
                </div>
            </div>
        )
    }

    renderVariantSelector = () => {
        return (
            <div style={{ marginTop: 32 }}>
                <h4>Variants</h4>

                {!this.state.selectedProductToTag && (
                    "Please select a product"
                )}

                {this.state.selectedProductToTag && this.state.selectedVariantSetIds.length === 0 && (
                    "Product doesn't have variants"
                )}

                {   this.state.selectedProductToTag && 
                    this.state.selectedProductToTag.variants && 
                    this.state.selectedProductToTag.variants.length > 0 && (

                    this.state.selectedProductToTag.variants.map(
                        
                        (_variant, index) => {
                            return (
                                <div>
                                    {_variant.name}: 
                                    <select 
                                        key={_variant._id}
                                        name={ index }
                                        onChange={ ( e ) => this.handleOnSelectVariant( index, _variant, e.target.value ) }
                                        onSelect={ ( e ) => this.handleOnSelectVariant( index, _variant, e.target.value ) }>
                                        
                                        <option></option>
                                        {_variant._set.map( ( variantSet, variantSetIndex ) => {
                                            return (
                                                <option 
                                                    key={variantSet._id} 
                                                    value={variantSetIndex}>
                                                    {variantSet.name}
                                                </option>
                                            )
                                        })}
                                    </select>
                                </div>
                            )
                        }

                    )

                )}

            </div>
        )
    }

    doDebouncedSearchProducts = ( searchParam ) => {

        // _getElasticSearchProducts({ searchParam, limit: 10, withVariants: true })
        _getSearchProducts({ searchParam, limit: 10 })
            .then( res => {
                
                this.setState({
                    pendingProductSearchResults: false,
                    productsFound: res.data.products
                });

            });

    }

    handleOnSearchProduct = ( e ) => {

        const searchParam = e.target.value;

        this.setState({
            searchParam,
            pendingProductSearchResults: true,
            selectedProductToTag: null
        })

        this.doDebouncedSearchProducts( searchParam );

    }

    handleOnSelectProductToTag = ( _product ) => {

        let selectedVariantSetIds = [];

        if( _product.variants && _product.variants.length > 0 ){
            for (let i = 0; i < _product.variants.length; i++) {
                selectedVariantSetIds.push(false);
            }
        }

        this.setState({
            productsFound: [],
            searchParam: _product.title,
            selectedProductToTag: _product,
            selectedVariantSetIds
        })

    }

    handleOnSelectVariant = ( variantIndex, variant, variantSetIndex ) => {

        console.log( variantIndex, variant, variant._set[variantSetIndex] );

        this.setState({
            selectedVariantSetIds: this.state.selectedVariantSetIds.map(
                (selectedVariant, i) => {

                    if( i == variantIndex ){
                        return {
                            variantName: variant.name,
                            variantSetName: variant._set[variantSetIndex].name
                        };
                    }

                    return selectedVariant;
                    
                }

            )
        })

    }

    handleOnTagProducts = () => {

        message.destroy();

        const { selectedVariantSetIds, selectedProductToTag } = this.state;
        const { selectedRfidTags } = this.props;

        if( !selectedProductToTag ){
            return message.error("Please select a product");
        }

        if( selectedVariantSetIds.filter( variant => !variant ).length > 0 ){
            return message.error("Please select a variant");
        }

        if( !selectedRfidTags || selectedRfidTags.length == 0 ){
            return message.error("No Rfid Tags Selected");
        }

        let quantity = selectedRfidTags.length;

        this.setState({
            pendingRetagOperation: true,
            retagOperationStep: 0
        })

        // message.loading("Requesting latest tag ids from the server");
        /**
         * 1. req x tags from server
         * 2. write to rfid tags
         * 3. set retagSuccess in server
         */
        _postGenerateRfidTag({ 
            quantity, 
            productId: selectedProductToTag._id,
            variantSetIds: selectedVariantSetIds
        })
            .then( res => {

                this.setState({
                    retagOperationStep: 1
                });
                // message.loading("Writing eezee tag ids to physical tags");

                const rfidTags = res.data.rfidTags;

                let writeTagsInstructions = selectedRfidTags.map( (physicalTag, i) => {
                    return {
                        from: physicalTag.tagId,
                        to: rfidTags[i].tagNumber
                    }
                })

                return _postWriteTagsToRfidServer( writeTagsInstructions )
                    .then( res => this._verifyTagsAreWritten( writeTagsInstructions ))

            })

            .then( writeTagsInstructions => this._setRetagSuccess( writeTagsInstructions ) )
            .then( res => {


                if( res.data.updateCount === !quantity ){
                    throw new Error("UPDATE COUNT DOESN'T MATCH QUANTITY");
                }

                message.success(`${quantity} RFID Tags tagged to eezee server`);

                this.setState({
                    retagOperationStep: 4
                })

                setTimeout( () => {

                    this.props.onCancel();

                    this.setState({
                        pendingRetagOperation: false
                    });    

                }, 1200);

            })
            .catch( e => {

                let shownError = false;

                if( e.response && e.response.data && e.response.data.errors ){

                    shownError = true;
                    message.error(e.response.data.errors);

                    this.setState({
                        pendingRetagOperation: false
                    })
                }

                // if unknown error
                if( !shownError ){

                    this.setState({
                        pendingRetagOperation: false
                    });

                    message.error(e.toString());
                    message.error("UNEXPECTED ERROR. OPEN DEVELOPER TOOLS AND SCREENSHOT ERROR");
                }

            })

    }

    _setRetagSuccess = ( writeTagsInstructions ) => {

        let retryCount = 0;

        const asyncSetRetagSuccess = () => {

            // message.loading("Notifying server of retag success");
            this.setState({
                retagOperationStep: 3
            });
            
            retryCount++;

            let tagIds = writeTagsInstructions.map( ({ to }) => to );
            let errorFlag = false;

            return _postSetRetagSuccess( tagIds )
                .then( res => {

                    if( !res.data.success ){
                        errorFlag = true;
                    }

                    return res;

                })
                .catch( e => {

                    errorFlag = true;


                })
                .finally( () => {
                    if( errorFlag && retryCount < 3 ){
                        return asyncSetRetagSuccess();
                    }

                    if( errorFlag && retryCount >= 3 ){
                        throw new Error("RETAG SUCCES FAILED");
                    }
                })

        }

        return new Promise( (resolve, reject ) => {

            asyncSetRetagSuccess()
                .then( ( res ) => {
                    resolve( res );
                })
                .catch( e => reject(e))

        });

    }

    _verifyTagsAreWritten = ( writeTagsInstructions ) => {

        let verifyCount = 0;

        let asyncGetTagsAndVerify = () => {

            this.setState({
                retagOperationStep: 2
            })
            // message.loading("Verifying tags are written");
            verifyCount++;

            let errorFlag = false;

            return _getReadTagsFromRfidServer( 2, 0 )
                .then( res => {
    
                    let tagsFound = res.data;
                    let tagMismatch = false;
    
                    writeTagsInstructions.map( ({from, to }) => {
    
                        if( !tagsFound[to] ){
                            tagMismatch = true;
                            message.error(`Can't find tag ${to}`);
                        }
    
                    });

                    if( tagMismatch ){
                        errorFlag = true;
                    }

                    return tagMismatch;
    
                })
                .catch( e => {

                    errorFlag = true;

                })
                .finally( () => {

                    if( errorFlag && verifyCount < 3 ){
                        return asyncGetTagsAndVerify();
                    }

                    if( errorFlag && verifyCount >= 3 ){
                        throw new Error("VERIFY TAGS FAILED");
                    }

                })

        }

        return new Promise( ( resolve, reject ) => {

            // verifies up to 3 times
            asyncGetTagsAndVerify()
                .then( tagMismatch => {

                    if( tagMismatch ){
                        return reject("Can't verify tags have been written");
                    }

                    resolve( writeTagsInstructions );
                })
                .catch( e => {
                    reject( e );
                })

        });

    }

}

export default TagProductModal;


// WEBPACK FOOTER //
// ./src/components/rfid/tag-product-modal.js